module.exports = __webpack_public_path__ + "assets/img/u4 (1).904fb59a.png";